import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import EditLegendStatsListTemplate from './templates/EditLegendStatsListTemplate'

function EditLegendStats({teamId, limit, orderBy}) {

    const [stats, setStats] = useState([])
    const [sortedStats, setSortedStats] = useState([])

    useEffect(() => {

        async function fetchStats() {

            try {
                const teamStatsRef = firestore.collection("teams").doc(teamId).collection("total-stats");
                teamStatsRef.orderBy("fixtures", "desc").limit(limit).onSnapshot(({docs}) => {
                    const stats = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setStats(stats)
                })
            } catch (error) {
                
            }

        }
        fetchStats()

    }, [teamId])

    useEffect(() => {

        if (stats) {
            const sortedStats = stats.sort((a, b) => {
                return +b.fixtures - +a.fixtures; 
            })
            console.log(sortedStats, "sorted stats")
            setSortedStats(sortedStats)
        }

    }, [stats])

    return (
        <div className="row">
            {sortedStats && sortedStats.map((player, index) => {
                return <EditLegendStatsListTemplate key={index} player={player} teamId={teamId} />
            })}
        </div>
    )
}
export default EditLegendStats